<template>
  <div class="content">
    <h1>Foto-Upload</h1>
    <span v-if="weiter">
        <p>Eigenen Namen eingeben (optional):</p>
        <input type="text" v-model="username" placeholder="Name">
    </span >
    <span v-else>
      <Upload :username="username" /><br />
    </span>
    <button v-on:click="saveName">{{buttonText}}</button>
  </div>
</template>

<script>
import Upload from '@/components/Upload/Upload'

export default {
  name: 'app',
  components: {
    Upload
  },
  data: function () {
    return {
      username: '',
      weiter: true,
      buttonText: 'Weiter'
    }
  },
  methods: {
    saveName: function () {
      if (this.weiter) {
        this.weiter = false
        this.buttonText = 'Zurück'
      } else {
        this.weiter = true
        this.buttonText = 'Weiter'
      }
      // this.$router.push('Upload')
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Upload/UploadContainer.vue